/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface InputRefundOrMarkAsExpired
 */
export interface InputRefundOrMarkAsExpired {
    /**
     * 
     * @type {number}
     * @memberof InputRefundOrMarkAsExpired
     */
    'serviceRequestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InputRefundOrMarkAsExpired
     */
    'action'?: InputRefundOrMarkAsExpiredActionEnum;
}

export const InputRefundOrMarkAsExpiredActionEnum = {
    Refund: 'refund',
    Expired: 'expired',
    ReOpen: 're-open'
} as const;

export type InputRefundOrMarkAsExpiredActionEnum = typeof InputRefundOrMarkAsExpiredActionEnum[keyof typeof InputRefundOrMarkAsExpiredActionEnum];


